document.addEventListener('DOMContentLoaded', function () {
  var section = document.getElementById('fc-myo-section');

  if (section && 'IntersectionObserver' in window) {
    var bgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fc-bg-visible');
        } else {
          entry.target.classList.remove('fc-bg-visible');
        }
      });
    }, { threshold: 0, rootMargin: '-10% 0px -10% 0px' });

    bgObserver.observe(section);
  } else if (section) {
    section.classList.add('fc-bg-visible');
  }

  var animEls = Array.prototype.slice.call(document.querySelectorAll('.fc-myo-anim'));

  animEls.forEach(function (el, index) {
    el.style.transitionDelay = (index * 90) + 'ms';
  });

  if ('IntersectionObserver' in window) {
    var elObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.2 });

    animEls.forEach(function (el) {
      elObserver.observe(el);
    });
  } else {
    animEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  var nameInput = document.getElementById('fc-myo-name');
  var numberInput = document.getElementById('fc-myo-number');
  var previewName = document.getElementById('fc-myo-preview-name');
  var previewNumber = document.getElementById('fc-myo-preview-number');

  if (!nameInput || !numberInput || !previewName || !previewNumber) return;

  var jerseyWrap = document.querySelector('.fc-myo__jersey-wrap');
  var nameTextPath = previewName.querySelector('textPath');
  var namePathEl = document.getElementById('fc-myo-name-path');
  var pathLength = namePathEl ? namePathEl.getTotalLength() : 180;
  var maxPathUsage = pathLength * 0.82;

  function fitNameToWidth() {
    if (!nameTextPath) return;
    var fontSize = 30;
    previewName.style.fontSize = fontSize + 'px';

    while (previewName.getComputedTextLength() > maxPathUsage && fontSize > 9) {
      fontSize -= 1;
      previewName.style.fontSize = fontSize + 'px';
    }
  }

  function updateName() {
    var value = nameInput.value.toUpperCase().replace(/[^A-Z ]/g, '');
    nameInput.value = value;
    nameTextPath.textContent = value || 'YOUR NAME';
    fitNameToWidth();
  }

  function updateNumber() {
    var value = numberInput.value.replace(/[^0-9]/g, '').slice(0, 2);
    numberInput.value = value;
    previewNumber.textContent = value || '00';
  }

  nameInput.addEventListener('input', updateName);
  numberInput.addEventListener('input', updateNumber);
  window.addEventListener('resize', fitNameToWidth);

  updateName();
  updateNumber();
});